var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "compass_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#compass_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22c1.933 0 3.583-.68 4.95-2.042C21.317 18.596 22 16.944 22 15c0-1.933-.683-3.583-2.05-4.95C18.583 8.683 16.933 8 15 8c-1.944 0-3.596.683-4.958 2.05C8.681 11.417 8 13.067 8 15c0 1.944.68 3.596 2.042 4.958C11.404 21.319 13.056 22 15 22zm0-3.154a6.05 6.05 0 01-3.256-.929 6.658 6.658 0 01-2.35-2.48.879.879 0 010-.873 6.644 6.644 0 012.355-2.481c1-.62 2.083-.93 3.251-.93 1.168 0 2.247.313 3.238.937a6.771 6.771 0 012.343 2.473.878.878 0 010 .873 6.677 6.677 0 01-2.343 2.481c-.99.62-2.07.93-3.238.93zm0-1.192c.949 0 1.822-.235 2.621-.706A5.065 5.065 0 0019.508 15a5.152 5.152 0 00-1.887-1.94A5.029 5.029 0 0015 12.346c-.959 0-1.84.238-2.641.714A5.141 5.141 0 0010.467 15a5.055 5.055 0 001.892 1.948c.802.47 1.682.706 2.641.706zm0-1.154c.417 0 .77-.143 1.063-.43A1.44 1.44 0 0016.5 15c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0015 13.5a1.44 1.44 0 00-1.07.438A1.46 1.46 0 0013.5 15c0 .427.143.784.43 1.07.286.287.643.43 1.07.43zm0 7a8.255 8.255 0 01-3.315-.67 8.605 8.605 0 01-2.697-1.818 8.608 8.608 0 01-1.819-2.697A8.256 8.256 0 016.5 15c0-1.17.223-2.27.67-3.3a8.541 8.541 0 014.515-4.53A8.256 8.256 0 0115 6.5c1.17 0 2.27.223 3.3.67a8.635 8.635 0 012.704 1.826A8.633 8.633 0 0122.83 11.7c.446 1.03.669 2.13.669 3.3a8.189 8.189 0 01-.53 2.948 8.866 8.866 0 01-1.464 2.514l3.477 3.477a.667.667 0 01.21.517.758.758 0 01-1.28.517l-3.467-3.452a8.725 8.725 0 01-2.513 1.457A8.252 8.252 0 0115 23.5z",
    fill: "#212121"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/compass.d9cbe643.svg";
export { SvgCompass as ReactComponent };